import Reveal from "@/components/feature/Reveal";

const heroStats = [
  { label: "已归组事件", value: "412" },
  { label: "待对照材料", value: "3,985" },
  { label: "本周新增", value: "168" },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full pt-24 md:pt-32 pb-14 md:pb-24 bg-background-50">
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        <div className="absolute inset-y-0 right-0 w-full lg:w-[46%] bg-background-100/70"></div>
      </div>

      <div className="relative w-full px-4 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-7">
            <Reveal>
              <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3.5 py-1.5 font-label text-xs md:text-sm text-primary-700">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                证据式整理 · 每份材料可回到原始内容
              </span>
            </Reveal>

            <Reveal delay={60}>
              <h1 className="mt-6 font-heading font-black text-foreground-950 leading-[1.15] text-3xl md:text-5xl lg:text-[3.35rem]">
                黑料爆料
                <span className="block mt-2 text-foreground-700 font-bold text-2xl md:text-4xl lg:text-[2.6rem]">
                  先看材料，再谈判断
                </span>
              </h1>
            </Reveal>

            <Reveal delay={120}>
              <p className="mt-6 max-w-xl font-body text-base md:text-lg leading-8 text-foreground-600">
                首页直接提供证据式整理，实锤、聊天记录、截图、录音等按事件归组。不用只看一句话，点开就能对照关键材料和原始内容，辅助判断事情的来龙去脉。
              </p>
            </Reveal>

            <Reveal delay={180}>
              <div className="mt-9 flex flex-col sm:flex-row sm:items-center gap-3">
                <a
                  href="#library"
                  className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3.5 font-label text-sm md:text-base text-background-50 dark:text-foreground-950 hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  <i className="ri-folder-open-line text-lg" aria-hidden="true"></i>
                  进入材料库
                </a>
                <a
                  href="#proof"
                  className="inline-flex items-center justify-center gap-2 rounded-md border border-background-300 bg-background-50 px-6 py-3.5 font-label text-sm md:text-base text-foreground-800 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
                >
                  <i className="ri-hammer-line text-lg" aria-hidden="true"></i>
                  先看实锤速览
                </a>
              </div>
            </Reveal>

            <Reveal delay={240}>
              <dl className="mt-11 grid grid-cols-3 gap-4 max-w-lg border-t border-background-200 pt-6">
                {heroStats.map((stat) => (
                  <div key={stat.label}>
                    <dt className="font-label text-xs md:text-sm text-foreground-500">{stat.label}</dt>
                    <dd className="mt-1.5 font-heading font-black text-2xl md:text-3xl text-foreground-950">
                      {stat.value}
                    </dd>
                  </div>
                ))}
              </dl>
            </Reveal>
          </div>

          <div className="lg:col-span-5">
            <Reveal delay={140}>
              <div className="relative">
                <div className="w-full aspect-[4/5] overflow-hidden rounded-lg bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=overhead%20editorial%20still%20life%20of%20neatly%20stacked%20evidence%20folders%20and%20sealed%20envelopes%20on%20a%20warm%20cream%20desk%2C%20one%20deep%20vermillion%20seal%20as%20accent%2C%20soft%20directional%20daylight%2C%20quiet%20minimal%20composition%2C%20no%20people&width=1000&height=1250&seq=blackproof-hero-01&orientation=portrait"
                    alt="证据材料归组示意：成叠的档案与信封材料摆放在浅色桌面上"
                    title="黑料爆料实锤证据按事件归组"
                    className="w-full h-full object-cover object-top"
                  />
                </div>

                <div className="absolute -bottom-5 left-4 md:left-6 right-4 md:right-auto md:max-w-xs rounded-lg border border-background-200 bg-background-50 p-4">
                  <p className="font-label text-xs text-foreground-500 tracking-wide">材料归组示例</p>
                  <p className="mt-1.5 font-heading font-bold text-foreground-950 text-sm md:text-base">
                    EV-2609-114 · 分成争议
                  </p>
                  <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 font-label text-xs text-foreground-600">
                    <span>聊天 36 段</span>
                    <span>截图 58 张</span>
                    <span>录音 3 条</span>
                  </div>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}